<template>
    <div v-if="show" class="loading-player">
        <LoadingSpinner />
    </div>
</template>

<script>
import LoadingSpinner from '../../components/LoadingSpinner';

export default {
    name: "LoadingPlayer",
    props: {
        show: { type: Boolean }
    },
    components: {
        LoadingSpinner
    }
}
</script>
